import React from "react"
import {graphql, StaticQuery} from "gatsby";

const RtapPhoneNumber = (data, props) => {
  // defaults (to be overwritten by props)
  let telNumber = "020 7600 1660"
  let classes = ""

  // Set the number we are working with passed via the props
  if(props.number) {
      telNumber = props.number
  }

  //
  // Upadated RT method, now a classless search of the DOM
  // Old method for ref: classes = 'RT-placeholder ' + node.field_rtap_code + ' ' + node.name.replace(/\s/g,'') 
  // RT-placeholder class retained for styling and targeting
  data.map(function(node, index) {
    if(node.name && telNumber) {
      if(node.name == telNumber){
        classes = 'RT-placeholder' 
      }
    }
  })

  // Apply any additional classes passed to the component for styling purposes
  if (props.additionalclasses) {
    classes = classes + ' ' + props.additionalclasses
  }

  let displayNumber = (<><a href={"tel:" + telNumber} className={classes} {...props}>{telNumber}</a></>)

  return (displayNumber)
}


const RtapGetPhoneNumbers = (props) => (
  <StaticQuery

    query={graphql`
      query {
        content: allTaxonomyTermResponsetapNumbers(filter: {status: {eq: true}}) {
          nodes {
            field_rtap_code
            name
          }
        }
      }
    `}

    render={data => (
      <>
        {RtapPhoneNumber(data.content.nodes, props)}
      </>
    )}
  />

)

export default RtapGetPhoneNumbers
